import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import events from './events'
import featureFlags from './featureFlags'
import user from './user'

export default combineReducers({
  events,
  featureFlags,
  user,
  form: formReducer,
})
